import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heading: {
		id: 'schools.classroom.heading',
		defaultMessage: 'Bring Calm to{break}your <decoratedtext>classroom</decoratedtext>',
		description: 'Calm Schools section heading',
	},
	copy: {
		id: 'schools.classroom.copy',
		defaultMessage:
			'Discover what’s possible if every school day began with a few moments of mindfulness. Together let’s equip students with tools for resilience, self-care, and stress management.',
		description: 'Calm Schools classroom description',
	},
	cta: {
		id: 'schools.schools.cta',
		defaultMessage: 'Join the movement',
		description: 'Classroom section button cta',
	},
});
